"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkSetSubscriptionDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ChainLinkSetSubscriptionDialog = () => {
    return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "vrfSubId" });
};
exports.ChainLinkSetSubscriptionDialog = ChainLinkSetSubscriptionDialog;
//# sourceMappingURL=index.js.map